import styles from './AboutMission.module.scss';
import { useScrollReveal } from '~/hooks/useScrollReveal';
import React from 'react';
import Mission from '../../../../../assets/img/about/Mission.svg';
import Image from 'next/image';

export const AboutMission = () => {
    const ref = React.useRef<HTMLDivElement>(null);
    const { hasRevealed } = useScrollReveal({ ref });
    const runAnimation = hasRevealed ? styles.runAnimation : '';

    return (
        <section id={'Mission'} className={`${styles.SectionContainer}`} ref={ref}>
            <div className={styles.SectionContent}>
                <div className={`${styles.TopContentContainer} ${runAnimation}`}>
                    <h2 className={`${styles.TopTitle} ${runAnimation}`}>Unlocking a legacy asset class</h2>
                    <p className={styles.TopDescription}>
                        As investments, fine wine and whiskey have traditionally been accessible only to the
                        well-connected few, and demanded managing a complex network of merchants, warehouse experts,
                        insurers, and exporters. Our team of world-class wine experts and top technology talent have
                        created a platform that curates premier wine and whiskey portfolios based on their individual
                        tastes and goals—with all the logistics handled.
                    </p>
                </div>
                <Image src={Mission} alt={'Mission'} />
            </div>
        </section>
    );
};
